<div mat-dialog-title align='center'>Upload Custom Points</div>
<mat-dialog-content align='left' class='s18-font'>
        How to upload custom points:
        <ul>
                <li>Download the Custom Point Sheet from the Event Info page.</li>
                <li>Open the file in Excel.</li>
                <li>Add the correct amount of points for each player.</li>
                <li>Save as CSV (DOS format).</li>
                <li>Select the file.</li>
                <li>Click upload to load the points for this event.</li>
        </ul>
        <h3>
                Please select a CSV file (DOS Format)
        </h3>
        <div fxLayout="row" fxLayoutAlign="space-between center">
                <button mat-raised-button color='primary' (click)='showFilePicker()'>
                        {{getFileName()}}
                </button>
                <div>
                        <mat-slide-toggle [(ngModel)]="addPoints">Add Points</mat-slide-toggle>
                        <span style='text-align:center; padding-left: 5px;' class='s18-font'
                                matTooltip="Add Points will add the points to your current event.  If you made a mistake and need to reset the points, reverify your event.">
                                <i class="fa fa-exclamation-circle"> </i>
                        </span>
                </div>
        </div>
        <input type='file' #file style="display:none" (change)='fileChangeListener($event)' />
        <div *ngIf="loadingComplete">{{statusText}}</div>
</mat-dialog-content>
<div mat-dialog-actions align="center">
        <button mat-raised-button color='accent' (click)='loadPoints()' [disabled]='!fileName'>Upload
                <i class='fa fa-spinner fa-spin' *ngIf='loading'></i>
        </button>
        <button mat-raised-button (click)="closeDialog()">Close</button>&nbsp;

</div>